module.exports = __webpack_public_path__ + "static/media/aaha_old.78294eaf.ogg";